import { Severity, addLog } from '../../../services/redux/consoleSlice';
import { useAppDispatch, type AppDispatch } from '../../../services/redux/hooks';
import { createLogPayload } from './utilsConsole';

function serializeError(error: any): string {
  // Safely extract properties from the error object
  const errorInfo = {
      message: error.message || "Unknown error",
      name: error.name || "Error",
      stack: error.stack || null,
  };

  // Additional properties can be added as needed...

  // Now, try to stringify the error
  try {
      return JSON.stringify(errorInfo);
  } catch (e) {
      // If the error still can't be stringified (very unlikely, unless the error object is very unusual)
      return JSON.stringify({
          message: "Unserializable error",
          name: "SerializationError",
      });
  }
}

export const useConsole = () => {
  // if (!dispatch) {
  //   console.log('getting new dispatch')
  //   dispatch = useAppDispatch();
  // }
  const handleArgument = (arg: any) => {
    if (typeof arg === 'object') {
      try {
        return JSON.stringify(arg, null, 2);
      } catch (err) {
        return arg.toString();
      }
    }
    return arg.toString();
  }
  const fnConsoleLog = (dispatch: AppDispatch,...args:any[]) => {
    const processedArgs = args.map(arg => handleArgument(arg));
    const message = processedArgs.join("\n");
    const payload = {
      message,
      severity: Severity.Informational,
      args,
    };
    try {
      console.log(payload)
      dispatch(addLog(payload))
    } catch (oErr) {
      console.log('Cant dispoatch')
    }
  };

  const fnConsoleError = (dispatch: AppDispatch, ...args: any[]) => {
    const payload = createLogPayload(...args);

    
    try {
      console.log(payload)
      dispatch(addLog(payload));
    } catch (oErr) {
      console.log('Cant dispatch for fnConsoleError', payload, oErr);
    }
  };
  
  
  // const fnConsoleError_old = (...args: any[]) => {
  //   const processedArgs = args.map(arg => handleArgument(arg));
  //   const message = processedArgs.join("\n");
  //   const payload = {
  //     message,
  //     severity: Severity.Error,
  //     args,
  //   };
  //   try {
  //     dispatch(addLog(payload));
  //   } catch (oErr) {
  //     console.log('Cant dispatch for fnConsoleError',payload,oErr);
  //   }
  // };

  
  return { fnConsoleLog, fnConsoleError };
};
